import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "riwayatangkakredit";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const riwayatangkakreditCreate =
  "Kepegawaian/RiwayatAngkaKredit/create/";
export const riwayatangkakreditList = "Kepegawaian/RiwayatAngkaKredit/list/";
export const riwayatangkakreditListJabfung =
  "Kepegawaian/RiwayatAngkaKredit/list_jabfung/";
export const SyncronizeJabfung =
  "Kepegawaian/RiwayatAngkaKredit/SyncronizeJabfung/";

export const riwayatangkakreditListAdmin =
  "Kepegawaian/RiwayatAngkaKredit/list_admin/";
export const riwayatangkakreditDetail =
  "Kepegawaian/RiwayatAngkaKredit/detail/";
export const riwayatangkakreditDetailJabfung =
  "Kepegawaian/RiwayatAngkaKredit/detailJabfung/";
export const riwayatangkakreditUpdate =
  "Kepegawaian/RiwayatAngkaKredit/update/";
export const riwayatangkakreditInactive =
  "Kepegawaian/RiwayatAngkaKredit/inactive/";
export const riwayatangkakreditActive =
  "Kepegawaian/RiwayatAngkaKredit/active/";
export const getEmployeebyUuid =
  "Kepegawaian/RiwayatAngkaKredit/getemployeebyuuid/";
//Tambahan
export const getuserpkpm = "Kepegawaian/RiwayatAngkaKredit/getuserpkpm/"

export const masterPosition = "Kepegawaian/Position/list/";
export const masterEchelon = "Kepegawaian/Echelon/list/";
export const masterPositionStatus = "Kepegawaian/PositionStatus/list/";
export const masterWorkUnit = "Kepegawaian/WorkUnit/list/";
export const masterSignatoryOfficial = "Kepegawaian/SignatoryOfficial/list/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
